export enum AccountTestEmailResultEvents {
  SUCCESS = 'account.test.email.sent',
  ERROR = 'account.test.email.failed',
}

export enum DateFormats {
  DATEONLY_SHORT = 'DD MMM',
  DATEONLY_SHORT_REVERSE = 'MMM DD',
  DATEONLY = 'MMM DD, YYYY',
  TIMEDATE = 'MMM DD, YYYY, HH:mm',
  TIMEDATE_SHORTEST = 'MMM DD, HH:mm',
  TIMEDATE_SHORT = 'DD MMM YY • HH:mm',
  DATEONLY_FULL_MONTH = 'MMMM Do YYYY',
  FULL_MONTH_YEAR = 'MMMM YYYY',
  SHORT_MONTH_YEAR = 'MMM YYYY',
  MONTH_SHORT = 'MMM',
  DATEONLY_DASHED = 'YYYY-MM-DD',
}

export enum DialogType {
  CONFIRMATION = 'confirmation',
  WARNING = 'warning',
  INFO = 'info',
}
